import { render, staticRenderFns } from "./hubWiseOFDReport_KSA.vue?vue&type=template&id=05697c4e&"
import script from "./hubWiseOFDReport_KSA.vue?vue&type=script&lang=js&"
export * from "./hubWiseOFDReport_KSA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports